import SlimSelect from 'slim-select'
import {tns} from 'tiny-slider'
import tippy from 'tippy.js'

const $ = require("jquery");
window.jQuery = $;
window.$ = $;


class tabbisClass {
    init(options) {
        this.thisOptions(options);
        this.thisMemory();
        this.setup();
    }

    // Setup
    setup() {
        const panes = document.querySelectorAll(this.options.paneGroup);
        const tabs = document.querySelectorAll(this.options.tabGroup);

        tabs.forEach((tabGroups, groupIndex) => {
            const paneGroups = panes[groupIndex];
            const activeIndex = this.getActiveIndex(tabGroups, groupIndex);

            tabGroups.setAttribute('role', 'tablist');

            // Reset items
            this.resetTabs([...tabGroups.children]);
            this.resetPanes([...paneGroups.children]);

            [...tabGroups.children].forEach((tabItem, tabIndex) => {
                const paneItem = paneGroups.children[tabIndex];

                // Add attributes
                this.addTabAttributes(tabItem, groupIndex);
                this.addPaneAttributes(tabItem, paneItem);

                tabItem.groupIndex = groupIndex;

                // Trigger event
                tabItem.addEventListener(this.options.trigger, (e) => {
                    this.activate(e.currentTarget, tabItem.groupIndex);
                });

                // Key event
                if (this.options.keyboardNavigation) {
                    tabItem.addEventListener('keydown', (e) => {
                        this.eventKey(e);
                    });
                }
            });

            if (activeIndex !== null) {
                this.activateTab([...tabGroups.children][activeIndex]);
                this.activatePane([...paneGroups.children][activeIndex]);
            }
        });
    }

    // Event key
    eventKey(e) {
        if ([13, 37, 38, 39, 40].includes(e.keyCode)) {
            e.preventDefault();
        }

        if (e.keyCode == 13) {
            e.currentTarget.click();
        } else if ([39, 40].includes(e.keyCode)) {
            this.step(e, 1);
        } else if ([37, 38].includes(e.keyCode)) {
            this.step(e, -1);
        }
    }

    // Index
    index(el) {
        return [...el.parentElement.children].indexOf(el);
    }

    // Step
    step(e, direction) {
        const children = e.currentTarget.parentElement.children;
        this.resetTabindex(children);

        let el = children[this.pos(e.currentTarget, children, direction)];
        el.focus();
        el.setAttribute('tabindex', 0);
    }

    resetTabindex(children) {
        [...children].forEach((child) => {
            child.setAttribute('tabindex', '-1');
        });
    }

    // Pos
    pos(tab, children, direction) {
        let pos = this.index(tab);
        pos += direction;

        if (children.length <= pos) {
            pos = 0;
        } else if (pos == -1) {
            pos = children.length - 1;
        }

        return pos;
    }

    // Emit event
    emitEvent(tab, pane) {
        let event = new CustomEvent('tabbis', {
            bubbles: true,
            detail: {
                tab: tab,
                pane: pane
            }
        });

        tab.dispatchEvent(event);
    }

    // Set active
    getActiveIndex(groupTabs, groupIndex) {
        const memory = this.loadMemory(groupIndex);

        if (typeof memory !== 'undefined') {
            return memory;
        } else {
            let element = groupTabs.querySelector(this.options.tabActive);

            if (!element) {
                element = groupTabs.querySelector('[aria-selected="true"]');
            }

            if (element) {
                return this.index(element);
            } else if (this.options.tabActiveFallback !== false) {
                return this.options.tabActiveFallback;
            } else {
                return null;
            }
        }
    }

    // ATTRIBUTES

    // Add tab attributes
    addTabAttributes(tab, groupIndex) {
        const tabIndex = this.index(tab);
        const prefix = this.options.prefix;

        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', `${prefix}tabpanel-${groupIndex}-${tabIndex}`);
        tab.setAttribute('id', `${prefix}tab-${groupIndex}-${tabIndex}`);
    }

    // Add tabpanel attributes
    addPaneAttributes(tab, pane) {
        pane.setAttribute('role', 'tabpanel');
        pane.setAttribute('aria-labelledby', tab.getAttribute('id'));
        pane.setAttribute('id', tab.getAttribute('aria-controls'));
        pane.setAttribute('tabindex', '0');
    }

    // Activate
    activate(tab, i) {
        const pane = document.querySelector(`#${tab.getAttribute('aria-controls')}`);

        this.resetTabs([...tab.parentNode.children]);
        this.resetPanes([...pane.parentElement.children]);

        this.activateTab(tab);
        this.activatePane(pane);

        this.saveMemory(tab, i);

        this.emitEvent(tab, pane);
    }

    // Activate tab
    activateTab(tab) {
        tab.setAttribute('aria-selected', 'true');
        tab.setAttribute('tabindex', '0');
    }

    // Activate pane
    activatePane(pane) {
        pane.removeAttribute('hidden');
    }

    // Remove tab attributes
    resetTabs(tabs) {
        tabs.forEach((el) => el.setAttribute('aria-selected', 'false'));
        this.resetTabindex(tabs);
    }

    // Reset pane attributes
    resetPanes(panes) {
        panes.forEach((el) => el.setAttribute('hidden', ''));
    }

    // MEMORY

    // Load memory
    loadMemory(groupIndex) {
        if (!this.options.memory) return;
        if (typeof this.memory[groupIndex] === 'undefined') return;
        if (this.memory[groupIndex] === null) return;

        return parseInt(this.memory[groupIndex]);
    }

    // Save memory
    saveMemory(tab, groupIndex) {
        if (!this.options.memory) return;
        this.memory[groupIndex] = this.index(tab);
        localStorage.setItem(this.options.memory, JSON.stringify(this.memory));
    }

    // This memory
    thisMemory() {
        if (!this.options.memory) return;
        const store = localStorage.getItem(this.options.memory);
        this.memory = store !== null ? JSON.parse(store) : [];
    }

    // OPTIONS

    // Defaults
    defaults() {
        return {
            keyboardNavigation: true,
            memory: false,
            paneGroup: '[data-panes]',
            prefix: '',
            tabActive: '[data-active]',
            tabActiveFallback: 0,
            tabGroup: '[data-tabs]',
            trigger: 'click'
        };
    }

    // This options
    thisOptions(options) {
        this.options = Object.assign(this.defaults(), options);
        if (this.options.memory !== true) return;
        this.options.memory = 'tabbis';
    }
}

// Function call
function tabbis(options = {}) {
    const tabs = new tabbisClass();
    tabs.init(options);
}


document.addEventListener("DOMContentLoaded", function () {
    let mobile = document.body.offsetWidth < 1200;

    let ignoreTypes = {
        м: true,
        тер: true,
        мост: true,
    };

    let forEach = (array, callback, scope) => {
        for (let i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i]); // passes back stuff we need
        }
    };

    async function postData(url = "", data = {}) {
        const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        return response.json();
    }

    let sendOnChange = (element) => {
        if ("createEvent" in document) {
            let evt = document.createEvent("HTMLEvents");
            evt.initEvent("input", false, true);
            element.dispatchEvent(evt);
        } else {
            element.fireEvent("oninput");
        }
    };

    function reg_keyboard(str) {
        let replacer = {
            q: "й",
            w: "ц",
            e: "у",
            r: "к",
            t: "е",
            y: "н",
            u: "г",
            i: "ш",
            o: "щ",
            p: "з",
            "[": "х",
            "]": "ъ",
            a: "ф",
            s: "ы",
            d: "в",
            f: "а",
            g: "п",
            h: "р",
            j: "о",
            k: "л",
            l: "д",
            ";": "ж",
            "'": "э",
            z: "я",
            x: "ч",
            c: "с",
            v: "м",
            b: "и",
            n: "т",
            m: "ь",
            ",": "б",
            ".": "ю",
            "/": ".",
        };
        return str.replace(/[A-z/,.;\'\]\[]/g, function (x) {
            return x == x.toLowerCase()
                ? replacer[x]
                : replacer[x.toLowerCase()].toUpperCase();
        });
    }

    let JSFilter = (sort) => {
        let nodeList = document.querySelectorAll(
            ".tarif-grid-item .slider-item"
        );
        let parentNode = nodeList[0].parentNode;
        let itemsArray = [];
        for (let i = 0; i < nodeList.length; i++) {
            itemsArray.push(parentNode.removeChild(nodeList[i]));
        }
        itemsArray
            .sort(function (nodeA, nodeB) {
                let val1 = parseInt(nodeA.dataset[sort]);
                let val2 = parseInt(nodeB.dataset[sort]);
                if (sort == "rating") {
                    if (val1 < val2) return 1;
                    if (val1 > val2) return -1;
                } else {
                    if (val1 < val2) return -1;
                    if (val1 > val2) return 1;
                }
                return 0;
            })
            .forEach(function (node) {
                parentNode.appendChild(node);
            });
    };

    let phoneInput = document.querySelectorAll(".phone-mask");
    forEach(phoneInput, function (index, value) {
        IMask(value, {
            mask: "+{7} (000) 000-00-00",
            prepare: (appended, masked) => {
                if (appended === "8" && masked.value === "") {
                    return "";
                }
                return appended;
            },
        });
    });

    // global func
    let bodyFixPosition = () => {
        setTimeout(function () {
            if (!document.body.hasAttribute("data-body-scroll-fix")) {
                let scrollPosition =
                    window.pageYOffset || document.documentElement.scrollTop; // Получаем позицию прокрутки
                document.body.setAttribute(
                    "data-body-scroll-fix",
                    scrollPosition
                ); // Cтавим атрибут со значением прокрутки
                document.body.style.overflow = "hidden";
                document.body.style.position = "fixed";
                document.body.style.top = "-" + scrollPosition + "px";
                document.body.style.left = "0";
                document.body.style.width = "100%";
            }
        }, 10);
    };
    let bodyUnfixPosition = () => {
        if (document.body.hasAttribute("data-body-scroll-fix")) {
            let scrollPosition = document.body.getAttribute(
                "data-body-scroll-fix"
            ); // Получаем позицию прокрутки из атрибута
            document.body.removeAttribute("data-body-scroll-fix"); // Удаляем атрибут
            document.body.removeAttribute("style");
            window.scroll(0, scrollPosition); // Прокручиваем на полученное из атрибута значение
        }
        let form_clear = document.querySelectorAll("form");
        if (form_clear) {
            [].forEach.call(form_clear, function (item) {
                let data = item.querySelector(".form-data__input");
                let result = item.querySelector(".form-data__result");
                let message = item.querySelector(".message");
                if (data) data.classList.remove("hide");
                if (result) result.classList.add("hide");
                if (message) {
                    item.querySelector(".message").innerHTML = "";
                }
            });
        }
    };

    let find_city = () => {
        const hiddenCityes = document.q;
        const parentDiv = document.querySelector(".live-search");
        const search_clear = parentDiv.querySelector(".modal-address__close");
        const searchInput = parentDiv.querySelector("#live-search");
        const search_list = parentDiv.querySelector("#city-get");
        const search_help = parentDiv.querySelector(".modal-address__info");
        searchInput.addEventListener("input", function (event) {
            let input = event.target;
            let query = reg_keyboard(event.target.value);
            let list = parentDiv.querySelectorAll(".city-item");
            let data = parentDiv.querySelectorAll(".city-item a");
            let clear_js = (ev1) => {
                ev1.closest(".city-item").style.display = "block";
                ev1.closest(".city-item").setAttribute("data-selects", "");
                ev1.parentNode.setAttribute("data-select", "");
                if (ev1.parentNode.getAttribute("data-priority"))
                    ev1.parentNode.style.display = "block";
                else ev1.parentNode.style.display = "none";
            };
            let add_js = (ev1) => {
                ev1.parentNode.style.display = "none";
                ev1.parentNode.removeAttribute("data-select");
                if (
                    !ev1
                        .closest(".city-item")
                        .contains(
                            ev1
                                .closest(".city-item")
                                .querySelector("[data-select]")
                        )
                ) {
                    ev1.closest(".city-item").style.display = "none";
                    ev1.closest(".city-item").removeAttribute("data-selects");
                }
            };
            if (input.value.length > 1) {
                search_clear.style.display = "flex";
                for (let i = 0, len = data.length; i < len; i++) {
                    data[i].innerHTML
                        .toLowerCase()
                        .includes(query.toLowerCase())
                        ? clear_js(data[i])
                        : add_js(data[i]);
                }

                for (let i = 0, lens = list.length; i < lens; i++) {
                    if (
                        list[i].parentNode.querySelectorAll("[data-selects]")
                            .length == 0
                    ) {
                        search_list.style.display = "none";
                        search_help.style.display = "block";
                    } else {
                        search_list.style.display = "block";
                        search_help.style.display = "none";
                    }
                }
            } else {
                search_clear.style.display = "none";
                for (let i = 0, len = data.length; i < len; i++) {
                    data[i].parentNode.removeAttribute("style");
                    data[i].parentNode.removeAttribute("data-select");
                    data[i]
                        .closest(".city-item")
                        .removeAttribute("data-selects");
                    data[i].closest(".city-item").removeAttribute("style");

                    if (
                        !(data[i].parentNode.getAttribute("data-priority") * 1)
                    ) {
                        data[i].parentNode.style.display = "none";
                    }
                    search_list.style.display = "block";
                    search_help.style.display = "none";
                }
            }
        });
        search_clear.onclick = function () {
            searchInput.value = "";
            searchInput.focus();
            sendOnChange(searchInput);
        };
    };

    function initToggle() {
        let toggle_table = document.querySelectorAll(".providers-content");
        if (toggle_table) {
            [].forEach.call(toggle_table, function (item) {
                item.querySelector(".providers-toggle__nav").addEventListener(
                    "click",
                    function () {
                        item.querySelector(
                            ".providers-toggle__nav"
                        ).classList.toggle("is-active");
                        item.querySelector(
                            ".providers-toggle__content"
                        ).classList.toggle("is-active");
                    }
                );
            });
        }
    }

    function initRating() {
        let raiting = document.querySelectorAll(".js_raiting");
        forEach(raiting, function (index, value) {
            let num = value.dataset.num;
            let size = value.dataset.size;
            let size_p = "";
            size == "big-size" ? (size_p = 19.7) : (size_p = 20.5);
            if (num) {
                let rating = num * size_p;
                value.querySelector(".stars_over_bg").style.width =
                    rating + "%";
            }
        });
    }

    function initTippyJS() {
        let tippyJS = document.querySelector("[data-tippy-content]");
        if (tippyJS) {
            tippy("[data-tippy-content]", {
                allowHTML: true,
                theme: "gigaboom",
            });
        }
    }

    function initModal() {
        MicroModal.init({
            onShow: (modal) => bodyFixPosition(), // [1]
            onClose: (modal) => bodyUnfixPosition(), // [2]
            openTrigger: "data-custom-open", // [3]
            closeTrigger: "data-micromodal-close", // [4]
            disableScroll: true, // [5]
            disableFocus: true, // [6]
            awaitOpenAnimation: true, // [7]
            awaitCloseAnimation: true, // [8]
            debugMode: false,
        });
    }

    function initTariffModal() {
        let modalopen = document.querySelector("[data-custom-open]");
        if (modalopen) {
            let modal_link = document.querySelectorAll("[data-custom-open]");

            modal_link.forEach(function (value) {
                value.addEventListener("click", function (evt) {
                    evt.preventDefault();
                    let type_modal = value.getAttribute("data-custom-open");
                    if (type_modal == "modal-tariff") {
                        let modal = document.getElementById("modal-tariff");
                        if (modal) {
                            modal
                                .querySelector(".popap-accordion_title")
                                .classList.remove("active");
                            modal
                                .querySelector(".popap-accordion_cnt")
                                .classList.remove("popap-accordion_cnt_open");
                            let card = this.closest(".js-modal-tariff");
                            if (card) {
                                const img = document.createElement("img");
                                img.src = card.dataset.logo;
                                modal.querySelector(".icon").appendChild(img);
                                modal.querySelector(
                                    "[name=provider_name]"
                                ).value = card.dataset.provider;
                                modal.querySelector("[name=type]").value =
                                    card.dataset.tariffType;
                                modal.querySelector(
                                    ".popap-accordion_title .name span"
                                ).innerHTML = card.dataset.title;

                                if (card.dataset.speedlimit) {
                                    modal.querySelector(
                                        ".field_speedlimit"
                                    ).style.display = "block";
                                    modal.querySelector(
                                        ".field_speedlimit .name span"
                                    ).innerHTML = card.dataset.speedlimit;
                                } else {
                                    modal.querySelector(
                                        ".field_speedlimit"
                                    ).style.display = "none";
                                    modal.querySelector(
                                        ".field_speedlimit .name span"
                                    ).innerHTML = "";
                                }

                                if (card.dataset.tvchanel) {
                                    modal.querySelector(
                                        ".field_tvlimit"
                                    ).style.display = "block";
                                    modal.querySelector(
                                        ".field_tvlimit .name span"
                                    ).innerHTML = card.dataset.tvchanel;
                                } else {
                                    modal.querySelector(
                                        ".field_tvlimit"
                                    ).style.display = "none";
                                    modal.querySelector(
                                        ".field_tvlimit .name span"
                                    ).innerHTML = "";
                                }

                                if (card.dataset.mob_traffic) {
                                    modal
                                        .querySelector(".field_phonelimit")
                                        .classList.add("hide-mobile");
                                    modal.querySelector(
                                        ".field_phonelimit"
                                    ).style.display = "block";
                                    modal.querySelector(
                                        ".field_phonelimit .name span"
                                    ).innerHTML = card.dataset.mob_traffic;
                                    modal.querySelector(
                                        ".field_phonelimit .desc strong"
                                    ).innerHTML = card.dataset.mob_min;
                                } else {
                                    modal
                                        .querySelector(".field_phonelimit")
                                        .classList.remove("hide-mobile");
                                    modal.querySelector(
                                        ".field_phonelimit"
                                    ).style.display = "none";
                                    modal.querySelector(
                                        ".field_phonelimit .name span"
                                    ).innerHTML = "";
                                    modal.querySelector(
                                        ".field_phonelimit .desc strong"
                                    ).innerHTML = "";
                                }

                                // modal.querySelector('.slider-cards__tooltip').innerHTML = card.querySelector('.slider-cards__tooltip').innerHTML;
                                modal.querySelector(
                                    ".field_connection_fee"
                                ).innerHTML = card.dataset.connection_fee;
                                modal.querySelector(".field_price").innerHTML =
                                    card.dataset.price;
                            }
                        }
                    }
                    if (type_modal == "modal-address") {
                        let search = document.getElementById("address-page-modal-address") || document.getElementById("modal-address");
                        search.querySelector(".street-input").focus();
                    }
                    if (type_modal == "modal-getCity") {
                        let url = "/cities-list/";
                        let cities_list = isSubdomain
                            ? url
                            : "/" + citySlug + url;
                        fetch(cities_list)
                            .then(function (response) {
                                return response.json();
                            })
                            .then(function (response) {
                                document.getElementById("city-get").innerHTML =
                                    response.cities;
                                find_city();
                            });
                    }
                    if (type_modal == "personal-data") {
                        let modal = document.getElementById("personal-data");
                        if (modal) {
                            modal.querySelector('.modal__container').style.maxWidth = '1000px';
                            let modal_content = modal.querySelector('.modal__content');
                            if (modal_content.innerHTML === '') {
                                $.get('/personal-data')
                                    .done(function (response) {
                                        modal.querySelector('.loading-img').style.display = 'none';
                                        modal_content.innerHTML = `<h2 class="text-center">${response.page.title}</h2>` + response.page.text;
                                    })
                                    .fail(function (xhr) {
                                        console.error('Ошибка:', xhr.status, xhr.statusText);
                                    });
                            }
                        }
                    }
                    if (type_modal == "personal-data-agreement") {
                        let modal = document.getElementById("personal-data-agreement");
                        if (modal) {
                            modal.querySelector('.modal__container').style.maxWidth = '1000px';
                            let modal_content = modal.querySelector('.modal__content');
                            if (modal_content.innerHTML === '') {
                                $.get('/personal-data-agreement')
                                    .done(function (response) {
                                        modal.querySelector('.loading-img').style.display = 'none';
                                        modal_content.innerHTML = `<h2 class="text-center">${response.page.title}</h2>` + response.page.text;
                                    })
                                    .fail(function (xhr) {
                                        console.error('Ошибка:', xhr.status, xhr.statusText);
                                    });
                            }
                        }
                    }
                });
            });
        }
    }

    //debounce func
    function debounce(func, timeout = 2000) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, timeout);
        };
    }

    // tariffs table
    let tabjs = document.querySelector("[data-tabs]");
    if (tabjs) {
        tabbis({
            memory: false,
        });

        let tabjsText = document.querySelector(".tab-js-text");
        if (tabjsText) {
            document.addEventListener(
                "tabbis",
                (e) => {
                    tabjsText.innerHTML = e.detail.tab.dataset.text;
                },
                false
            );
        }
    }

    // page address search tariff

    let home_tariffs = document.querySelectorAll(".search-tariffs-js");
    if (home_tariffs) {
        forEach(home_tariffs, function (index, value) {
            let tariffs_name = value.querySelector(
                "input[name=provider]"
            ).value;
            hometariffsLoad(tariffs_name, value);
        });
    }

    function hometariffsLoad(name, value, limit, from) {
        limit = limit ? limit : 4;
        from = from ? from : 0;
        let containers = value.querySelector(".tariffs_list");
        let url = "";
        if (!isSubdomain) {
            url = "/" + citySlug;
        }
        url +=
            "/tariffs-list?provider_name=" +
            name +
            "&limit=" +
            limit +
            "&from=" +
            from;

        if (value.querySelector("input[name=search]")) {
            url += "&" + value.querySelector("input[name=search]").value;
        }

        let loading = value.querySelector(".loading-img");
        if (loading != undefined) loading.style.display = "none";
        fetch(url)
            .then(function (response) {
                return response.json();
            })
            .then(function (response) {
                if (response.tariffs && response.success == true) {
                    containers.innerHTML = response.tariffs;
                    let load_more = value.querySelector(".load-more");
                    if (load_more) {
                        if (response.has_more)
                            load_more.style.display = "block";
                        else load_more.style.display = "none";

                        load_more
                            .querySelector("button")
                            .addEventListener("click", function (e) {
                                e.preventDefault();
                                hometariffsLoad(name, value, limit + 6);
                            });
                    }

                    initTippyJS();
                    initModal();
                    initTariffModal();
                } else {
                    containers.innerHTML =
                        '<div class="page-content__alert none">Тарифы не найдены.</div>';
                }
            });
    }

    function declOfNum(number, titles) {
        let cases = [2, 0, 1, 1, 1, 2];
        return titles[
            number % 100 > 4 && number % 100 < 20
                ? 2
                : cases[number % 10 < 5 ? number % 10 : 5]
            ];
    }

    function updateURL(new_url) {
        if (history.pushState) {
            var baseUrl =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname;
            var newUrl = baseUrl + new_url;
            history.pushState(null, null, newUrl);
        } else {
            console.warn("History API не поддерживается");
        }
    }

    function getGet(name) {
        var s = window.location.search;
        s = s.match(new RegExp(name + "=([^&=]+)"));
        return s ? s[1] : false;
    }

    function parseNumber(value) {
        return parseFloat(value.replace(',', '.'));
    }

    initRating();
    initModal();
    initTariffModal();
    initTippyJS();
    initToggle();


    forEach(
        document.querySelectorAll("[data-service-cost]"),
        function (index, checkbox) {
            checkbox.addEventListener("click", function () {
                if (checkbox.checked) {
                    let toggle = document.getElementById(
                        checkbox.dataset.toggle
                    );
                    if (toggle) {
                        toggle.checked = false;
                    }
                }
            });

            checkbox.addEventListener("change", function () {
                let sum = 0,
                    iSum = 0;

                forEach(
                    document.querySelectorAll("[data-service-cost]:checked"),
                    (index, el) => {
                        if (el.dataset.type != "installment") {
                            sum += parseNumber(el.dataset.serviceCost); // Используем parseFloat
                        } else {
                            iSum += parseNumber(el.dataset.serviceCost); // Используем parseFloat
                        }
                    }
                );

                forEach(
                    document.querySelectorAll("[data-price]"),
                    (index, el) => {
                        el.innerHTML = parseFloat(el.dataset.price) + sum; // Используем parseFloat
                    }
                );

                forEach(
                    document.querySelectorAll("[data-i-price]"),
                    (index, el) => {
                        el.innerHTML = parseFloat(el.dataset.iPrice) + iSum; // Используем parseFloat
                    }
                );
            });
        }
    );

    // authorization

    let authorization_btn = document.querySelector(".authorization-toggle-btn");
    let authorization_login = document.querySelector("#authorization-login");
    let authorization_reg = document.querySelector("#authorization-reg");
    authorization_btn.onclick = function (evt) {
        evt.preventDefault();
        if (authorization_btn.innerHTML === "Регистрация на сайте") {
            authorization_btn.innerHTML = "Войти в аккаунт";
        } else {
            authorization_btn.innerHTML = "Регистрация на сайте";
        }
        authorization_login.classList.toggle("hide");
        authorization_reg.classList.toggle("hide");
    };

    // menu

    let open_menu = document.querySelectorAll(".header__burger");
    let close_menu = document.querySelector(".fixed_menu_close");
    let fixed_menu = document.querySelector(".fixed_menu");

    forEach(open_menu, function (index, value) {
        value.onclick = function (evt) {
            evt.preventDefault();
            bodyFixPosition();
            fixed_menu.classList.add("nav-open");
        };
    });

    if (close_menu) {
        close_menu.onclick = function (evt) {
            evt.preventDefault();
            bodyUnfixPosition();
            fixed_menu.classList.remove("nav-open");
        };
    }

    // dropdown menu
    let header__drop_open = document.querySelectorAll(".header__drop-title");
    forEach(header__drop_open, function (index, value) {
        value.onclick = function () {
            let isClosed = value
                .closest(".header__drop")
                .classList.contains("is-active");
            let drop_active = value
                .closest(".header")
                .querySelectorAll(".header__drop");
            Array.from(drop_active).forEach((item) => {
                item.classList.remove("is-active");
            });
            // если меню было закрыто, то открываем его
            if (isClosed == false) {
                value.closest(".header__drop").classList.add("is-active");
            }
        };
    });

    document.addEventListener("click", function (event) {
        var e = document.querySelector(".header__drop.is-active");
        if (e) {
            if (!e.contains(event.target)) e.classList.remove("is-active");
        }
    });

    // dropdown rating
    let ratings__drop_open = document.querySelectorAll(".ratings__drop-title");
    forEach(ratings__drop_open, function (index, value) {
        value.onclick = function () {
            let isClosed = value
                .closest(".ratings__drop")
                .classList.contains("is-active");
            let drop_active = value
                .closest(".ratings-table")
                .querySelectorAll(".ratings__drop");
            Array.from(drop_active).forEach((item) => {
                item.classList.remove("is-active");
            });
            // если меню было закрыто, то открываем его
            if (isClosed == false) {
                value.closest(".ratings__drop").classList.add("is-active");
            }
        };
    });

    document.addEventListener("click", function (event) {
        var e = document.querySelector(".ratings__drop.is-active");
        if (e) {
            if (!e.contains(event.target)) e.classList.remove("is-active");
        }
    });

    // spoiler
    let js_accordion = document.querySelectorAll(".js-accordion-open");
    forEach(js_accordion, function (index, value) {
        value.onclick = function () {
            value
                .closest(".js-accordion")
                .querySelector(".js-accordion-content")
                .classList.toggle("is-active");
            value.classList.toggle("active");
        };
    });

    let popap_accordion = document.querySelectorAll(".popap-accordion_title");
    forEach(popap_accordion, function (index, value) {
        value.onclick = function () {
            value
                .closest(".popap-accordion")
                .querySelector(".popap-accordion_cnt")
                .classList.toggle("popap-accordion_cnt_open");
            value.classList.toggle("active");
        };
    });

    // modal tab
    let modal_tab = document.querySelectorAll(".modal-tabnav_item");
    forEach(modal_tab, function (index, value) {
        value.onclick = function (evt) {
            evt.preventDefault();
            document
                .querySelector(".modal-tabnav_item.active")
                .classList.remove("active");
            value.classList.add("active");
            document
                .querySelector(".modal-tabcontent_item.active")
                .classList.remove("active");
            document
                .querySelector("[id=" + value.dataset["opentab"] + "]")
                .classList.add("active");
        };
    });

    let fixed_price = document.querySelector("#fixed_price");
    if (fixed_price) {
        let checkPrice = () => {
            // Detect scroll position
            let scrollPosition = Math.round(window.scrollY),
                top_price = document
                    .querySelector("#tarif_block_price")
                    .getBoundingClientRect().top;
            if (scrollPosition - 300 >= top_price) {
                fixed_price.classList.add("hide");
            } else {
                fixed_price.classList.remove("hide");
            }
        };
        window.addEventListener("scroll", checkPrice);
    }

    // open tarif price
    let open_price_tarif = document.querySelectorAll(".open_price_tarif");
    forEach(open_price_tarif, function (index, value) {
        value.onclick = function (e) {
            e.preventDefault();
            document.querySelector("#order_block_price").scrollIntoView({
                behavior: "smooth",
                block: "end",
            });
        };
    });

    // scroll to block
    document.querySelectorAll(".scroll_link").forEach((link) => {
        if (link.getAttribute("href") && !link.getAttribute("scrollTo")) {
            link.setAttribute(
                "scrollTo",
                link.getAttribute("href").substring(1)
            );
        }
        // link.addEventListener("click", function (e) {
        //   e.preventDefault();
        //   if (this.getAttribute("href")) {
        //     let href = this.getAttribute("href").substring(1);
        //     const scrollTarget = document.getElementById(href);
        //     const topOffset = 70; // если не нужен отступ сверху
        //     const elementPosition = scrollTarget.getBoundingClientRect().top;
        //     const offsetPosition = elementPosition - topOffset;
        //     window.scrollBy({
        //       top: offsetPosition,
        //       behavior: "smooth",
        //     });
        //   }
        // });
    });

    let isTablet =
        /iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(
            navigator.userAgent.toLowerCase()
        ) || window.innerWidth < 1200;

    let sliders = document.querySelectorAll(".slider-desktop");
    if (sliders) {
        forEach(sliders, function (index, value) {
            let id_slider = value.dataset.id;
            let slider_width = value.dataset.width == "small" ? 260 : 330;
            let slider = tns({
                container: value,
                items: 3,
                controls: true,
                nav: false,
                loop: false,
                gutter: 15,
                mouseDrag: true,
                fixedWidth: slider_width,
                controlsPosition: "bottom",
                slideBy: "page",
                preventActionWhenRunning: false,
                speed: 600,
                disable: true,
                touch: true,
                controlsText: [
                    '<span class="icon-arrow"></span>',
                    '<span class="icon-arrow"></span>',
                ],
            });

            if (isTablet) {
                slider.destroy();
                initModal();
                initTariffModal();
                initTippyJS();
            }
        });

        if (!isTablet) {
            let easeInOutQuad = function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return (c / 2) * t * t + b;
                t--;
                return (-c / 2) * (t * (t - 2) - 1) + b;
            };

            function scrollTo(element, to, duration) {
                let start = element.scrollLeft,
                    change = to - start,
                    currentTime = 0,
                    increment = 5;

                let animateScroll = function () {
                    currentTime += increment;
                    let val = easeInOutQuad(
                        currentTime,
                        start,
                        change,
                        duration
                    );
                    element.scrollLeft = val;
                    if (currentTime < duration) {
                        setTimeout(animateScroll, increment);
                    }
                };

                animateScroll();
            }

            forEach(
                document.querySelectorAll(".tns-controls"),
                function (index, ctrl) {
                    ctrl.style.display = "flex";

                    let parCont = ctrl.parentNode.parentNode;

                    let cont =
                        ctrl.previousSibling.querySelector(".slider-desktop");

                    let btns = ctrl.querySelectorAll("button");

                    let itemWidth = parCont.classList.contains(
                        "slider-container-big"
                    )
                        ? 340
                        : 273;

                    let itemMul = parCont.classList.contains(
                        "slider-container-big"
                    )
                        ? 3
                        : 4;

                    let itemCount =
                        cont.querySelectorAll(".slider-item").length;

                    let maxScrollLeft = parseInt(itemCount * itemWidth - 1185);

                    if (cont.scrollLeft <= maxScrollLeft) {
                        cont.classList.remove("justify-center");
                    }
                    let checkBtns = function () {
                        btns[0].style.visibility =
                            cont.scrollLeft == 0 ? "hidden" : "visible";
                        btns[1].style.visibility =
                            cont.scrollLeft >= maxScrollLeft
                                ? "hidden"
                                : "visible";
                    };

                    cont.onscroll = checkBtns;

                    let setScroll = function (left) {
                        left = parseInt(left / itemWidth) * itemWidth;
                        //cont.scrollLeft = left;
                        scrollTo(cont, left, 350);
                        checkBtns();
                    };

                    let next = function () {
                        setScroll(cont.scrollLeft + itemWidth * itemMul);
                    };

                    let prev = function () {
                        setScroll(cont.scrollLeft - itemWidth * itemMul);
                    };

                    btns[0].style.visibility = "hidden";

                    btns[0].onclick = function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        prev();
                        return false;
                    };

                    if (itemCount <= itemMul) {
                        btns[1].style.visibility = "hidden";
                    }

                    btns[1].onclick = function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        next();
                        return false;
                    };
                }
            );
        }
    }

    let sliders_promo = document.querySelector(".slider_promo");
    if (sliders_promo) {
        sliders_promo = tns({
            preventScrollOnTouch: "auto",
            container: ".slider_promo",
            slideBy: "page",
            items: 1,
            controls: false,
            mouseDrag: false,
            navPosition: "bottom",
        });
    }

    // filter mobile
    let ProviderSort = document.getElementById("js-provider-sort");
    if (ProviderSort) {
        ProviderSort.addEventListener("change", function () {
            let sort = this.value;
            JSFilter(sort);
        });
    }

    // filter desktop ver
    let ProviderSortPC = document.querySelectorAll("#js-provider-sort-pc li");
    forEach(ProviderSortPC, function (index, value) {
        value.onclick = function (e) {
            let act_link = value
                .closest("#js-provider-sort-pc")
                .querySelector("li.is-active");
            if (act_link) {
                act_link.classList.remove("is-active");
            }
            value.classList.add("is-active");
            let sort = value.getAttribute("value");
            JSFilter(sort);
        };
    });

    // send form
    forEach(
        document.querySelectorAll(".js-modal-submit-order"),
        function (index, form) {
            const form_button = form.querySelector(".js-submit-form");
            let form_button_t = "";
            if (form_button) {
                form_button_t = form_button.innerHTML;
            }
            form.addEventListener("submit", (event) => {
                event.preventDefault();
                if (form_button) {
                    form_button.innerHTML = "Отправка...";
                    form_button.disabled = false;
                }

                let data_form = form.querySelector(".form-data__input");
                let data_result = form.querySelector(".form-data__result");
                let msg_el = form.querySelector(".message");

                let request = {
                    name: form.querySelector("[name=name]").value,
                    phone: form.querySelector("[name=phone]").value,
                    customer_text: "",
                };

                let el = form.querySelector("[name=call_time]");
                if (el) {
                    request.call_time = el.value;
                }

                el = form.querySelector("[name=provider_name]");
                if (el) {
                    request.provider_name = el.value;
                }

                el = form.querySelector(".popap-accordion_title .name span");
                if (el) {
                    request.tariff_name = el.innerText;
                }

                forEach(
                    document.querySelectorAll("[data-name]:checked"),
                    function (i, checkbox) {
                        request.customer_text += checkbox.dataset.name + "\n";
                    }
                );

                postData(form.getAttribute("action"), request)
                    .then((data) => {
                        if (data.errors) {
                            let errorsMessages = "";

                            const errors = Object.values(data.errors);
                            errorsMessages = errors.flat().join("<br />");

                            msg_el.innerHTML =
                                `<span class="error">` +
                                errorsMessages +
                                `</span>`;
                            if (data_form.parentElement.classList.contains("free-consultation__form")) {
                                msg_el.style.display = "flex";
                            }
                            form_button.innerHTML = 'Отправить';
                        } else {
                            if (data_form.parentElement.classList.contains("free-consultation__form")) {
                                //вывод попапа для блока консультации
                                const consultModal = document.getElementById('free-consultation-modal');
                                consultModal.classList.add('active');
                                msg_el.style.display = "none";
                            } else {
                                if (data_form || data_result) {
                                    data_form.classList.add("hide");
                                    data_result.classList.remove("hide");
                                }
                            }
                            form.querySelectorAll('.field').forEach(input => input.value = '');
                            msg_el.innerHTML = `<span class="success"></span>`;
                            form_button.innerHTML = 'Отправить';
                        }
                    })
                    .catch(function (error) {
                        msg_el.innerHTML = `<span class="error">Не удалось отправить заявку, попробуйте позже.</span>`;

                        if (data_form.parentElement.classList.contains("free-consultation__form")) {
                            msg_el.style.display = "flex";
                        }
                        form_button.innerHTML = form_button_t;
                    });
            });
        }
    );

    // select address mobile

    let search_mask = (where, text) => {
        var markInstance = new Mark(where);
        let input_value = text;
        var options = {};
        markInstance.unmark({
            done: function () {
                markInstance.mark(input_value, options);
            },
        });
    };

    function suggest(query, street_id) {
        let serviceUrl = `https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address`;
        const cityMap = {
            7700000000000: 'москва',
            7800000000000: 'санкт-петербург'
        };

        let locations = [{
            city: cityMap[kladr],
            kladr_id: cityMap[kladr] ? undefined : kladr,
            street_fias_id: street_id
        }];

        let request = {
            query: query,
            count: 12,
            locations,
            from_bound: {value: "street"},
            to_bound: {value: "house"},
        };

        let params = {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Token " + token,
            },
            body: JSON.stringify(request),
        };
        return fetch(serviceUrl, params);
    }

    const search_streets = document.querySelectorAll("#modal-address, #address-page-modal-address");
    search_streets.forEach(search_street => {
        let street = search_street.querySelector(".street-input");
        let plachelder_street = document.querySelector(".input_street");
        let streetInp = street;
        let street_id = "";

        let wrap = search_street.querySelector("#address-page-suggestions") || search_street.querySelector("#suggestions");

        let search_help = search_street.querySelector(".modal-address__info");
        let search_clear = search_street.querySelector(".modal-address__close");

        let result_start = search_street.querySelector(".search-address__proccess");
        let result_end = search_street.querySelector(".search-address__result");
        let result_bad = search_street.querySelector(".search-address__bad");
        let result_close = search_street.querySelectorAll(".close_result");

        if (result_close) {
            result_close.forEach(function (item) {
                item.addEventListener("click", function () {
                    result_start.style.display = "block";
                    result_end.style.display = "none";
                    result_bad.style.display = "none";
                });
            });
        }

        function closeTouch() {
            var el = document.querySelector("body");
            el.addEventListener("touchstart", swipeTouch, false);
        }

        function swipeTouch() {
            street.blur();
        }

        closeTouch();

        if (street) {
            street.addEventListener("input", debounce((e) => onChange(e), 500));

            function onChange(e) {
                if (e.target.value.length > 1) {
                    if (search_clear) search_clear.style.display = "flex";
                    wrap.style.display = "block";
                    let promise = suggest(e.target.value, street_id);
                    search_help.classList.add("hide");
                    promise
                        .then(function (response) {
                            return response.json();
                        })
                        .then(function (suggestions) {
                            wrap.innerHTML = "";
                            for (let key in suggestions["suggestions"]) {
                                if (
                                    ignoreTypes[
                                        suggestions["suggestions"][key]["data"]
                                            .street_type
                                        ]
                                ) {
                                    continue;
                                }
                                // не показываем адреса без house_fias_id
                                if (suggestions["suggestions"][key]["data"]["house"] && suggestions["suggestions"][key]["data"].house_fias_id == null) {
                                    continue;
                                }

                                let street =
                                    suggestions["suggestions"][key]["data"][
                                        "street_with_type"
                                        ];
                                if (street) {
                                    let house =
                                        suggestions["suggestions"][key]["data"][
                                            "house"
                                            ];
                                    let house_in =
                                        house === null ? "" : ", " + house;

                                    let house_fias_id =
                                        suggestions["suggestions"][key]["data"][
                                            "house_fias_id"
                                            ];
                                    let street_fias_id =
                                        suggestions["suggestions"][key]["data"][
                                            "street_fias_id"
                                            ];

                                    let block_type =
                                        suggestions["suggestions"][key]["data"][
                                            "block_type"
                                            ];
                                    if (
                                        block_type == "лит" ||
                                        block_type == "литер"
                                    )
                                        block_type = "";
                                    if (block_type == "стр")
                                        block_type = " " + block_type + " ";
                                    let block =
                                        suggestions["suggestions"][key]["data"][
                                            "block"
                                            ];
                                    block =
                                        block === null ? "" : block_type + block;

                                    let city =
                                        suggestions["suggestions"][key]["data"][
                                            "city"
                                            ];
                                    let region =
                                        suggestions["suggestions"][key]["data"][
                                            "region"
                                            ];
                                    let region_with_type =
                                        suggestions["suggestions"][key]["data"][
                                            "region_with_type"
                                            ] || "";
                                    let area_with_type =
                                        ". " +
                                        suggestions["suggestions"][key]["data"][
                                            "area_with_type"
                                            ] +
                                        ". " || "";
                                    let settlement_with_type =
                                        suggestions["suggestions"][key]["data"][
                                            "settlement_with_type"
                                            ] || "";

                                    let uniqueAddress = "";
                                    if (
                                        suggestions["suggestions"][key]["data"][
                                            "block"
                                            ] &&
                                        suggestions["suggestions"][key]["data"][
                                            "block_type"
                                            ]
                                    ) {
                                        uniqueAddress =
                                            suggestions["suggestions"][key]["data"][
                                                "city_kladr_id"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "street_with_type"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "house"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "block_type"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "block"
                                                ];
                                    } else {
                                        uniqueAddress =
                                            suggestions["suggestions"][key]["data"][
                                                "city_kladr_id"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "street_with_type"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "house"
                                                ];
                                    }

                                    // city = '<div class="city">' + city + '</div>';
                                    if (city) {
                                        city =
                                            city == region
                                                ? region_with_type
                                                : city;
                                    } else {
                                        city =
                                            region_with_type +
                                            area_with_type +
                                            settlement_with_type;
                                    }

                                    if (settlement_with_type) {
                                        city += ", " + settlement_with_type;
                                    }

                                    region = '<div class="city">' + city + "</div>";

                                    if (house === null) {
                                        let div = document.createElement("div");
                                        div.innerHTML =
                                            '<div class="suggestions-item" data-id="' +
                                            street_fias_id +
                                            '"><div class="title suggestions__title">' +
                                            street +
                                            "</div>" +
                                            region +
                                            "</div>";
                                        wrap.append(div);
                                    } else {
                                        let div = document.createElement("div");
                                        div.innerHTML =
                                            '<div class="suggestions-item"><a href="#" class="js-select-house" data-fias="' +
                                            house_fias_id +
                                            '"></a><div class="title">' +
                                            street +
                                            house_in +
                                            block +
                                            "</div>" +
                                            region +
                                            "</div>";
                                        let el =
                                            div.querySelector(".js-select-house");
                                        el.addEventListener(
                                            "click",
                                            function (evt) {
                                                evt.preventDefault();

                                                let house_fias_id =
                                                    evt.target.dataset.fias;
                                                var clickedSuggesstion =
                                                    suggestions["suggestions"].find(
                                                        (sug) =>
                                                            sug.data
                                                                .house_fias_id ==
                                                            house_fias_id
                                                    );

                                                getUrl(
                                                    uniqueAddress,
                                                    clickedSuggesstion
                                                )
                                                    .then(function (response) {
                                                        return response.json();
                                                    })
                                                    .then(function (result) {
                                                        if (result.url) {
                                                            location.href =
                                                                result.url;
                                                            //location.href = '/tariffs';
                                                        } else {
                                                            // document.querySelector(".search-address__proccess").style.display = "none";
                                                            // document.querySelector(".search-address__result").style.display = "block";
                                                            // document.querySelector(".search-address__bad").style.display = "block";
                                                            location.href =
                                                                "/internet-po-adresu/other-results";
                                                        }
                                                    })
                                                    .catch(function (error) {
                                                        console.log(error);
                                                    });
                                            }
                                        );
                                        wrap.append(div);
                                    }

                                    let address_list =
                                        document.querySelectorAll(
                                            ".suggestions-item"
                                        );
                                    address_list.forEach(function (item) {
                                        search_mask(
                                            item.querySelector(
                                                ".suggestions__title"
                                            ),
                                            reg_keyboard(e.target.value)
                                        );
                                        if (house === null) {
                                            item.onclick = function (evt) {
                                                streetInp.value =
                                                    item.querySelector(
                                                        ".suggestions__title"
                                                    ).textContent + " ";
                                                street_id =
                                                    item.getAttribute("data-id");
                                                sendOnChange(streetInp);
                                                streetInp.focus();
                                            };
                                        }
                                    });
                                }
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                    if (plachelder_street) plachelder_street.value = e.target.value;
                } else {
                    search_help.classList.remove("hide");
                    wrap.innerHTML = "";
                    wrap.style.display = "none";
                    if (search_clear) search_clear.style.display = "none";
                    street_id = "";
                    if (plachelder_street) plachelder_street.value = "";
                }
            }

            function getUrl(unique_address, choosedSuggestion) {
                let request = {
                    citySlug: citySlug,
                    unique_address: unique_address,
                };

                if (choosedSuggestion != undefined) {
                    let hwb = choosedSuggestion.data.house;

                    if (choosedSuggestion.block_type != null) {
                        hwb += choosedSuggestion.data.block_type;
                    }

                    if (choosedSuggestion.data.block != null) {
                        hwb += choosedSuggestion.data.block;
                    }

                    request.area = choosedSuggestion.data.area;
                    request.house_fias_id = choosedSuggestion.data.house_fias_id;
                    request.street_with_type =
                        choosedSuggestion.data.street_with_type;
                    request.house_with_block = hwb;
                    request.kladr = choosedSuggestion.data.city_kladr_id;
                    request.geo_lat = choosedSuggestion.data.geo_lat;
                    request.geo_lon = choosedSuggestion.data.geo_lon;
                }
                let serviceUrl = `/api/street_url/`;

                let params = {
                    method: "POST",
                    body: JSON.stringify(request),
                };
                return fetch(serviceUrl, params);
            }

            search_clear.onclick = function () {
                street.value = "";
                plachelder_street.value = "";
                street.focus();
                sendOnChange(street);
            };
        }
        // select address desktop

        if (street && street.value.trim().length > 0) {
            sendOnChange(street);
        }
    })

    // ??? mb checkbox with page single tariff

    let tits = document.querySelectorAll(".tarif-info-three");
    [].forEach.call(tits, function (tit) {
        let labels = tit.querySelectorAll("label");
        if (labels.length < 3) return;
        labels[1].style.position = "relative";
        labels[1].style.top = "5px";
    });

    // custom select

    let custom_select = document.querySelectorAll(".js-select");
    let slimSelectInstances = [];

    if (custom_select) {
        [].forEach.call(custom_select, function (item) {
            const instance = new SlimSelect({
                select: item,
                showSearch: false,
                showContent: "auto",
            });
            slimSelectInstances.push(instance); // Сохраняем экземпляр в массив
        });
    }

    function clearSelects() {
        slimSelectInstances.forEach(instance => {
            if (instance.config.isMultiple) {
                instance.set([]);
            } else {
                instance.set('');
            }
        })
    }


    let submitForm = document
        .querySelectorAll(".submit-form")
        .forEach((btn) => {
        });
    $(".submit-form").on("click", function (e) {
        e.preventDefault();

        var submit = $(this);
        var form = $(this).closest("form");
        var link = form.attr("action");

        $.each(form.find("span.text-danger"), function (key, value) {
            $(this).text("");
            $(this).siblings("input").removeClass("has-danger");
        });

        $.ajax({
            url: link,
            method: "post",
            dataType: "json",
            data: form.serialize(),
            success: function (data) {
                if (data.redirectTo != undefined) {
                    document.location.href = data.redirectTo;
                } else if (data.message != undefined) {
                    notifyModal(data.message);
                }
                if (data.name != undefined) {
                    document.querySelector("#user-menu").innerHTML = data.name;
                }
                MicroModal.close("modal-authorization");
                MicroModal.close("modal-forget-password");
            },
            error: function (err) {
                var fg, span;
                if (err.status == 422 || err.status == 423) {
                    $.each(err.responseJSON.errors, function (key, value) {
                        var input = $('input[name="' + key + '"]', form);
                        input.addClass("has-danger");
                        span = input.siblings("span");
                        if (!span.length) span = input.siblings("span.error");
                        if (value[0] instanceof Object) {
                            var errs = "";
                            $.each(value[0], function (key, value) {
                                errs += value + "<br>";
                            });
                            span.html(errs);
                        } else span.html(value[0]);
                        //span.show();
                    });

                    if (err.responseJSON.flash != undefined) {
                        notifyModal(err.responseJSON.flash);
                    }
                } else {
                    notifyModal(
                        "Неправильный ответ от сервера, попробуйте позже!"
                    );
                }
            },
            complete: function (e) {
            },
        });
        return false;
    });

    function notifyModal(message, type) {
        var modal = document.getElementById("modal-notify");
        var textContent = modal.querySelector(".form-info");
        textContent.innerHTML = message;
        MicroModal.show("modal-notify");
        setTimeout(function () {
            MicroModal.close("modal-notify");
        }, 4000);
    }

    let reviewProviders = document
        .querySelectorAll(".reviews-select__item")
        .forEach((value) => {
            value.addEventListener("click", (event) => {
                let page = 1;
                if (value.classList.contains("is-active"))
                    value.classList.remove("is-active");
                else value.classList.add("is-active");

                let activeProviders = activeReviewsProviders();
                let container = document.getElementById("reviews_list");
                container.innerHTML = "";
                loadReviews(activeProviders.join(","), page);
            });
        });

    function activeReviewsProviders() {
        let providers = [];
        let actives = document
            .querySelectorAll(".reviews-select__item.is-active")
            .forEach((item1) => {
                if (item1.dataset.provider != undefined)
                    providers.push(item1.dataset.provider);
            });

        return providers;
    }

    function loadReviews(providers, page) {
        if (page == undefined) page = 1;
        if (providers == undefined) providers = "";
        let url = "";
        if (!isSubdomain) {
            url = "/" + citySlug;
        }
        url += "/reviews/search?page=" + page + "&providers=" + providers;
        let container = document.getElementById("reviews_list");
        let loading = document.querySelector(".loading");
        if (loading != undefined) loading.style.display = "block";
        fetch(url)
            .then(function (response) {
                return response.json();
            })
            .then(function (response) {
                if (response.success == true) {
                    container.innerHTML += response.reviews;
                    initRating();
                }
                loading.style.display = "none";
                if (response.count) {
                    document.querySelector(".reviews-total").innerHTML =
                        response.count;
                } else {
                    container.innerHTML =
                        "<div class='page-content__alert none'>Отзывов пока нет, станьте первым, оцените своего провайдера!</div>";
                }
                let load_more = document.querySelector(".load-more");
                if (load_more) {
                    if (response.hasMore) load_more.style.display = "block";
                    else load_more.style.display = "none";
                    load_more.dataset.page = page;
                    load_more
                        .querySelector("button")
                        .addEventListener("click", function (e) {
                            e.preventDefault();
                            loadReviews(
                                providers,
                                load_more.dataset.page * 1 + 1
                            );
                        });
                }
            })
            .catch(function (error) {
                container.innerHTML =
                    "<div class='page-content__alert none'>Отзывы не найдены</div>";
            });
    }

    let resetReviews = document.querySelector(".reviews-select__reset");
    if (resetReviews != undefined) {
        loadReviews("", 1);
        resetReviews.addEventListener("click", function () {
            document
                .querySelectorAll(".reviews-select__item.is-active")
                .forEach((item1) => {
                    item1.classList.remove("is-active");
                });
            let container = document.getElementById("reviews_list");
            container.innerHTML = "";
            loadReviews("", 1);
        });
    }

    // nav providers
    if (document.querySelector(".providers-nav")) {
        let menuSection = document.querySelectorAll(".providers-nav a");
        menuSection.forEach((v) => {
            v.onclick = (e) => {
                e.preventDefault();
                menuSection.forEach((j) => j.classList.remove("active"));
                v.classList.add("active");
            };
        });

        window.onscroll = () => {
            let mainSection = document.querySelectorAll(".provider-tariffs");
            let f = document.querySelector(".providers-nav");
            let secScr = document.querySelector(".blocks");

            var st = document.documentElement.scrollTop;
            if (st > secScr.getBoundingClientRect().y) {
                f.classList.add("visible");
            } else {
                f.classList.remove("visible");
            }

            mainSection.forEach((v, i) => {
                let rect = v.getBoundingClientRect().y;
                if (rect < window.innerHeight / 10 - 40) {
                    menuSection.forEach((v) => v.classList.remove("active"));
                    menuSection[i].classList.add("active");
                }
            });
        };
    }

    // Steps Modal Form Search address

    // if (
    //   window.location.hash &&
    //   document.querySelector("#modal-success-address")
    // ) {
    //   var hash = window.location.hash.substring(1);
    //   if (hash == "show_modal") {
    //     MicroModal.show("modal-success-address");
    //     bodyFixPosition();
    //     // history.pushState("", document.title, window.location.pathname);
    //   }
    // }
    function isYandexReferrer() {
        const yandexDomains = [
            'yandex', 'ya.ru'
        ];
        return yandexDomains.some(domain => document.referrer.includes(domain));
    }

    if (
        document.referrer &&
        document.querySelector("#modal-success-address") &&
        window.performance &&
        performance.navigation.type !== 1
    ) {
        MicroModal.show("modal-success-address");
        bodyFixPosition();
    }

    if (
        document.querySelector(".internet-po-adresu") &&
        document.referrer &&
        document.referrer.includes("internet-po-adresu") &&
        window.performance &&
        performance.navigation.type !== 1
    ) {
        const yOffset = -50;
        const element = document.querySelector(".internet-po-adresu");
        const y =
            element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({top: y, behavior: "smooth"});
    }

    const modal_home = document.querySelector("#modal-success-address");
    let modal_home_close = document.querySelectorAll(".close-success-address");
    if (modal_home_close) {
        [].forEach.call(modal_home_close, function (item) {
            item.addEventListener("click", function () {
                bodyUnfixPosition();
                MicroModal.close("modal-success-address");
            });
        });
    }

    if (modal_home) {
        // const search_form_open = document.querySelector(".js-open-modal-form");
        // search_form_open.addEventListener("click", function () {
        //   modal_home.querySelector(".addres-step-1").classList.add("hide");
        //   modal_home.querySelector(".addres-step-2").classList.remove("hide");
        // });

        const form_home = modal_home.querySelector(
            "form.js-form_address_success"
        );
        const form_home_button = form_home.querySelector(".js-send-button");
        let form_home_button_t = "";
        if (form_home_button) {
            form_home_button_t = form_home_button.innerHTML;
        }
        let form_home_phone = modal_home.querySelector(".check-mobilephone");
        form_home_phone.addEventListener("input", () => {
            form_home.querySelector(".placeholder-error").classList.add("hide");
        });

        form_home.addEventListener("submit", (event) => {
            event.preventDefault();
            form_home_button.innerHTML = "Отправка...";
            let request = {
                name:
                    form_home.querySelector("[name=name]").value ||
                    "Заявка без имени",
                customer_text:
                    "Адрес:" + form_home.querySelector("[name=street]").value,
                phone: form_home.querySelector("[name=phone]").value,
            };

            if (!/^\+7 \(9\d{2}\) \d{3}-\d{2}-\d{2}$/.test(request.phone)) {
                modal_home
                    .querySelector(".placeholder-error")
                    .classList.remove("hide");
                modal_home
                    .querySelector(".js-form-cancel")
                    .classList.remove("hide");
                form_home_button.innerHTML = form_home_button_t;
                return false;
            }

            postData(form_home.getAttribute("action"), request)
                .then((data) => {
                    modal_home
                        .querySelector(".addres-step-1")
                        .classList.add("hide");
                    modal_home
                        .querySelector(".addres-step-2")
                        .classList.remove("hide");
                    form_home_button.innerHTML = form_home_button_t;
                })
                .catch(function (error) {
                    console.log(
                        "Не удалось отправить заявку, попробуйте позже."
                    );
                    form_home_button.innerHTML = form_home_button_t;
                });
        });
    }

    //
    //  QUIZ
    //

    const modal_quiz = document.getElementById("modal-quiz");
    if (modal_quiz) {
        const quiz_title = modal_quiz.querySelector(".modal-quiz__question");
        const quiz_next = modal_quiz.querySelector(".modal-quiz__button.next");
        const quiz_back = modal_quiz.querySelector(".modal-quiz__button.back");
        const quiz_step = modal_quiz.querySelector(
            ".modal-quiz__procces .current"
        );
        const quiz_step_line = modal_quiz.querySelector(".modal-quiz__steps");
        const quiz_close = modal_quiz.querySelectorAll(".quiz_close");

        if (quiz_close) {
            quiz_close.forEach(function (item) {
                item.addEventListener("click", function () {
                    modal_quiz
                        .querySelector(".modal-form-quiz-result")
                        .classList.add("hide");
                    modal_quiz
                        .querySelector(".search-address__results")
                        .classList.add("hide");
                    modal_quiz
                        .querySelector(".modal-form-quiz-data")
                        .classList.remove("hide");
                    modal_quiz
                        .querySelector(".modal-quiz-flex")
                        .classList.remove("hide");
                });
            });
        }

        quiz_next.addEventListener("click", (event) => {
            event.preventDefault();
            let current_page = quiz_next.dataset.page;
            let back_page = quiz_back.dataset.page;
            let next = +current_page + 1;
            let back = +back_page + 1;
            if (next > quiz_next.dataset.max) {
                modal_quiz
                    .querySelector(".modal-quiz-flex")
                    .classList.add("hide");
                modal_quiz
                    .querySelector(".search-address__results")
                    .classList.remove("hide");
            } else {
                quiz_next.dataset.page = next;
                quiz_back.dataset.page = back;
                quiz_step.innerHTML = next;
                quiz_step_line.dataset.step = next;

                switch (next) {
                    case 1:
                        quiz_title.innerHTML = quiz_title.dataset.step1;
                        break;
                    case 2:
                        quiz_title.innerHTML = quiz_title.dataset.step2;
                        break;
                    case 3:
                        quiz_title.innerHTML = quiz_title.dataset.step3;
                        break;
                    case 4:
                        quiz_title.innerHTML = quiz_title.dataset.step4;
                        break;
                }

                if (next == quiz_next.dataset.max) {
                    quiz_next.querySelector("span").innerHTML = "Последний шаг";
                } else {
                    quiz_next.querySelector("span").innerHTML = "Далее";
                }
                modal_quiz
                    .querySelectorAll(".modal-quiz__js-step > div")
                    .forEach((v) => {
                        v.classList.add("hide");
                    });
                modal_quiz
                    .querySelector("#quiz_step_" + next)
                    .classList.remove("hide");
                if (quiz_back.dataset.page != 0) {
                    quiz_back.classList.remove("hidden");
                }
            }
        });
        quiz_back.addEventListener("click", (event) => {
            event.preventDefault();
            let current_page = quiz_back.dataset.page;
            let back_page = quiz_back.dataset.page;
            if (back_page != 0) {
                let next = back_page == 0 ? +current_page - 1 : 1;
                let back = +back_page - 1;
                quiz_next.dataset.page = next;
                quiz_back.dataset.page = back;
                quiz_step.innerHTML = back_page;
                quiz_step_line.dataset.step = back_page;

                switch (back + 1) {
                    case 1:
                        quiz_title.innerHTML = quiz_title.dataset.step1;
                        break;
                    case 2:
                        quiz_title.innerHTML = quiz_title.dataset.step2;
                        break;
                    case 3:
                        quiz_title.innerHTML = quiz_title.dataset.step3;
                        break;
                    case 4:
                        quiz_title.innerHTML = quiz_title.dataset.step4;
                        break;
                }

                if (next == quiz_next.dataset.max) {
                    quiz_next.querySelector("span").innerHTML = "Последний шаг";
                } else {
                    quiz_next.querySelector("span").innerHTML = "Далее";
                }

                modal_quiz
                    .querySelectorAll(".modal-quiz__js-step > div")
                    .forEach((v) => {
                        v.classList.add("hide");
                    });
                modal_quiz
                    .querySelector("#quiz_step_" + current_page)
                    .classList.remove("hide");
                if (quiz_back.dataset.page == 0) {
                    quiz_back.classList.add("hidden");
                }
            }
        });

        const form_quiz = modal_quiz.querySelector(".js-form-quiz");
        const phone_quiz = form_quiz.querySelector(".check-mobilephone");
        const address_quiz = form_quiz.querySelector(".quiz-address");
        const form_quiz_button = form_quiz.querySelector(".js-send-button");
        let form_quiz_button_t = "";
        if (form_quiz_button) {
            form_quiz_button_t = form_quiz_button.innerHTML;
        }
        phone_quiz.addEventListener("input", () => {
            modal_quiz
                .querySelector(".placeholder-error")
                .classList.add("hide");
        });
        if (address_quiz) {
            const quiz_suggestions_wrap = modal_quiz.querySelector(".quiz_suggestions")
            let streetInp = document.querySelector(".street-input");
            let street_id = "";
            address_quiz.addEventListener("input", debounce((e) => onQuizAddressChange(e), 500));

            function onQuizAddressChange(e) {
                if (e.target.value.length > 1) {
                    quiz_suggestions_wrap.style.display = "block";
                    let promise = suggest(e.target.value, street_id);
                    promise
                        .then(function (response) {
                            return response.json();
                        })
                        .then(function (suggestions) {
                            quiz_suggestions_wrap.innerHTML = "";
                            for (let key in suggestions["suggestions"]) {
                                if (
                                    ignoreTypes[
                                        suggestions["suggestions"][key]["data"]
                                            .street_type
                                        ]
                                ) {
                                    continue;
                                }

                                let street =
                                    suggestions["suggestions"][key]["data"][
                                        "street_with_type"
                                        ];
                                if (street) {
                                    let house =
                                        suggestions["suggestions"][key]["data"][
                                            "house"
                                            ];
                                    let house_in =
                                        house === null ? "" : ", " + house;

                                    let house_fias_id =
                                        suggestions["suggestions"][key]["data"][
                                            "house_fias_id"
                                            ];
                                    let street_fias_id =
                                        suggestions["suggestions"][key]["data"][
                                            "street_fias_id"
                                            ];

                                    let block_type =
                                        suggestions["suggestions"][key]["data"][
                                            "block_type"
                                            ];
                                    if (
                                        block_type == "лит" ||
                                        block_type == "литер"
                                    )
                                        block_type = "";
                                    if (block_type == "стр")
                                        block_type = " " + block_type + " ";
                                    let block =
                                        suggestions["suggestions"][key]["data"][
                                            "block"
                                            ];
                                    block =
                                        block === null ? "" : block_type + block;

                                    let city =
                                        suggestions["suggestions"][key]["data"][
                                            "city"
                                            ];
                                    let region =
                                        suggestions["suggestions"][key]["data"][
                                            "region"
                                            ];
                                    let region_with_type =
                                        suggestions["suggestions"][key]["data"][
                                            "region_with_type"
                                            ] || "";
                                    let area_with_type =
                                        ". " +
                                        suggestions["suggestions"][key]["data"][
                                            "area_with_type"
                                            ] +
                                        ". " || "";
                                    let settlement_with_type =
                                        suggestions["suggestions"][key]["data"][
                                            "settlement_with_type"
                                            ] || "";

                                    let uniqueAddress = "";
                                    if (
                                        suggestions["suggestions"][key]["data"][
                                            "block"
                                            ] &&
                                        suggestions["suggestions"][key]["data"][
                                            "block_type"
                                            ]
                                    ) {
                                        uniqueAddress =
                                            suggestions["suggestions"][key]["data"][
                                                "city_kladr_id"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "street_with_type"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "house"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "block_type"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "block"
                                                ];
                                    } else {
                                        uniqueAddress =
                                            suggestions["suggestions"][key]["data"][
                                                "city_kladr_id"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "street_with_type"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "house"
                                                ];
                                    }

                                    // city = '<div class="city">' + city + '</div>';
                                    if (city) {
                                        city =
                                            city == region
                                                ? region_with_type
                                                : city;
                                    } else {
                                        city =
                                            region_with_type +
                                            area_with_type +
                                            settlement_with_type;
                                    }

                                    if (settlement_with_type) {
                                        city += ", " + settlement_with_type;
                                    }

                                    region = '<div class="city">' + city + "</div>";

                                    let div = document.createElement("div");

                                    div.innerHTML =
                                        '<div class="quiz-suggestion suggestions-item" data-id="' +
                                        street_fias_id +
                                        '"><div class="title suggestions__title">' +
                                        street +
                                        house_in +
                                        block +
                                        "</div>" +
                                        region +
                                        "</div>";

                                    quiz_suggestions_wrap.append(div);

                                    let address_list =
                                        document.querySelectorAll(
                                            ".quiz-suggestion"
                                        );
                                    address_list.forEach(function (item) {
                                        search_mask(
                                            item.querySelector(
                                                ".suggestions__title"
                                            ),
                                            reg_keyboard(e.target.value)
                                        );
                                        item.onclick = function (evt) {
                                            document.querySelector(
                                                ".quiz-address"
                                            ).value =
                                                item.querySelector(
                                                    ".suggestions__title"
                                                ).textContent + " ";
                                            street_id =
                                                item.getAttribute("data-id");
                                            sendOnChange(streetInp);
                                            document
                                                .querySelector(".quiz-address")
                                                .focus();
                                        };
                                    });
                                }
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                } else {
                    quiz_suggestions_wrap.innerHTML = "";
                    street_id = "";
                }
            }
        }

        form_quiz.addEventListener("submit", (event) => {
            event.preventDefault();
            form_quiz_button.innerHTML = "Отправка...";
            let request = {
                name: form_quiz.querySelector("[name=name]").value,
                phone: form_quiz.querySelector("[name=phone]").value,
                customer_text:
                    "Адрес: " +
                    form_quiz.querySelector("[name=address]").value +
                    "\n",
            };

            forEach(
                form_quiz.querySelectorAll("input:checked"),
                function (i, item) {
                    request.customer_text +=
                        item.name + ": " + item.value + "\n";
                }
            );

            if (request.phone.length < 18) {
                form_quiz
                    .querySelector(".placeholder-error")
                    .classList.remove("hide");
                form_quiz_button.innerHTML = form_quiz_button_t;
                return false;
            }

            postData(form_quiz.getAttribute("action"), request)
                .then((data) => {
                    modal_quiz
                        .querySelector(".modal-form-quiz-data")
                        .classList.add("hide");
                    modal_quiz
                        .querySelector(".search-address__results")
                        .classList.add("hide");
                    modal_quiz
                        .querySelector(".modal-quiz-flex")
                        .classList.remove("hide");
                    modal_quiz
                        .querySelector(".modal-form-quiz-result")
                        .classList.remove("hide");
                    form_quiz_button.innerHTML = form_quiz_button_t;
                })
                .catch(function (error) {
                    console.log(
                        "Не удалось отправить заявку, попробуйте позже."
                    );
                    form_quiz_button.innerHTML = form_quiz_button_t;
                });
        });
    }

    // form office
    const form_office = document.querySelector(".js-form-office");
    if (form_office) {
        const form_office_result = form_office.querySelector(".form-office__result");
        const form_office_button = form_office.querySelector(".js-send-button");
        let form_office_button_t = "";
        if (form_office_button) {
            form_office_button_t = form_office_button.innerHTML;
        }
        form_office.addEventListener("submit", (event) => {
            event.preventDefault();
            form_office_button.innerHTML = "Отправка...";
            let request = {
                name: form_office.querySelector("[name=name]").value,
                phone: form_office.querySelector("[name=phone]").value,
                customer_text:
                    "Комментарий: " +
                    form_office.querySelector("[name=office_text]").value +
                    "\n",
            };

            forEach(
                form_office.querySelectorAll("input:checked"),
                function (i, item) {
                    request.customer_text +=
                        item.name + ": " + item.value + "\n";
                }
            );

            forEach(
                form_office.querySelectorAll("option:checked"),
                function (i, item) {
                    request.customer_text +=
                        item.closest("select").name + ": " + item.value + "\n";
                }
            );

            postData(form_office.getAttribute("action"), request)
                .then((data) => {
                    if (data.errors) {
                        form_office.querySelectorAll('.error-message').forEach(el => el.remove());
                        form_office.querySelectorAll('input').forEach((input) => {
                            const errors = data.errors[input.name];
                            if (errors) {
                                const errorMessages = data.errors[input.name];
                                let label = document.getElementById(input.id + '-errors');

                                let errorText = errorMessages.join('<br/>');
                                label.innerHTML = `<p class="error-message error">` +
                                    errorText +
                                    `</p>`;
                            }
                        })
                        form_office_button.innerHTML = 'Отправить заявку'
                    } else {
                        form_office.querySelectorAll('.error-message').forEach(el => el.remove());
                        form_office_button.innerHTML = form_office_button_t;
                        form_office.querySelectorAll('input').forEach(input => {
                            input.value = '';
                        })
                        form_office.querySelector('textarea').value = '';
                        clearSelects();
                        form_office_result.classList.add('active');
                        form_office_result.querySelector(".success-message").style = 'display: block';
                        setTimeout(() => {
                            form_office_result.classList.remove('active');
                            form_office_result.querySelector(".success-message").style = 'display: none';
                        }, 3000);
                    }
                })
                .catch(function (error) {
                    console.log(error)
                    form_office_button.innerHTML = form_office_button_t;
                    form_office_result.classList.add('active');
                    form_office_result.querySelector(".error-message").style = 'display: block';
                    setTimeout(() => {
                        form_office_result.classList.remove('active');
                        form_office_result.querySelector(".error-message").style = 'display: none';
                    }, 3000);
                });
        });
    }

    // fixed header
    let elSelector = ".fixed-header";
    let element = document.querySelector(elSelector);
    if (element) {
        var elHeight = 0,
            elTop = 0,
            dHeight = 0,
            wHeight = 0,
            wScrollCurrent = 0,
            wScrollBefore = 0,
            wScrollDiff = 0;
        let header_drop_active = document.querySelectorAll(".header__drop");
        window.addEventListener("scroll", function () {
            elHeight = element.offsetHeight;
            dHeight = document.body.offsetHeight;
            wHeight = window.innerHeight;
            wScrollCurrent = window.pageYOffset;
            wScrollDiff = wScrollBefore - wScrollCurrent;
            elTop =
                parseInt(window.getComputedStyle(element).getPropertyValue("top")) +
                wScrollDiff;
            if (wScrollCurrent > 250) {
                element.classList.add("show_menu");
            } else {
                element.classList.remove("show_menu");
                header_drop_active.forEach((item) => {
                    item.classList.remove("is-active");
                });
            }

            if (wScrollCurrent <= 0) element.style.top = "0px";
            else if (wScrollDiff > 0)
                element.style.top = (elTop > 0 ? 0 : elTop) + "px";
            else if (wScrollDiff < 0) {
                if (wScrollCurrent + wHeight >= dHeight - elHeight)
                    element.style.top =
                        ((elTop = wScrollCurrent + wHeight - dHeight) < 0
                            ? elTop
                            : 0) + "px";
                else
                    element.style.top =
                        (Math.abs(elTop) > elHeight ? -elHeight : elTop) + "px";
            }

            wScrollBefore = wScrollCurrent;
        });
    }

    const modal_provider_name = document.querySelector(
        "[name=provider_name_modal]"
    );
    const filter_provider_name_select = document.querySelector(
        "select[name=provider_name]"
    );
    let filter_provider_name;
    if (filter_provider_name_select) {
        filter_provider_name = new SlimSelect({
            select: document.querySelector("select[name=provider_name]"),
            showSearch: false,
            showContent: "auto",
        });
    }
    if (modal_provider_name && filter_provider_name_select) {
        modal_provider_name.addEventListener("change", () => {
            filter_provider_name.set(modal_provider_name.value);
        });
    }

    const modal_provider_type = document.querySelector(
        "[name=provider_type_modal]"
    );
    const filter_provider_type_select = document.querySelector(
        "select[name=provider_type]"
    );
    let filter_provider_type;
    if (filter_provider_type_select) {
        filter_provider_type = new SlimSelect({
            select: filter_provider_type_select,
            showSearch: false,
            showContent: "auto",
        });
    }
    if (modal_provider_type && filter_provider_type_select) {
        modal_provider_type.addEventListener("change", () => {
            filter_provider_type.set(modal_provider_type.value);
        });
    }

    const modal_provider_sort = document.querySelector(
        "[name=provider_sort_modal]"
    );
    const filter_provider_sort_select = document.querySelector(
        "select[name=provider_sort]"
    );
    let filter_provider_sort;
    if (filter_provider_sort_select) {
        filter_provider_sort = new SlimSelect({
            select: filter_provider_sort_select,
            showSearch: false,
            showContent: "auto",
        });
    }
    if (modal_provider_sort && filter_provider_sort_select) {
        modal_provider_sort.addEventListener("change", () => {
            filter_provider_sort.set(modal_provider_sort.value);
        });
    }

    // search on page address

    const internetAddress = document.querySelector(".internet-po-adresu");
    if (internetAddress) {
        const internetAddress_clear = internetAddress.querySelector(
            ".page-search-address__close"
        );
        const internetAddressInput = internetAddress.querySelector(
            "[name=page-search-address-input]"
        );
        const internetAddress_list = internetAddress.querySelector(".column");
        const internetAddress_help = internetAddress.querySelector(
            ".page-search-address__help"
        );
        internetAddressInput.addEventListener("input", function (event) {
            let input = event.target;
            let query = reg_keyboard(event.target.value);
            let list = internetAddress_list.querySelectorAll(".item");
            let data = internetAddress_list.querySelectorAll(".item a");
            let clear_js = (ev1) => {
                ev1.closest(".item").style.display = "grid";
                ev1.closest(".item").setAttribute("data-selects", "");
                ev1.parentNode.setAttribute("data-select", "");
                // if (ev1.getAttribute("data-select"))
                //   ev1.parentNode.style.display = "grid";
                // else ev1.parentNode.style.display = "none";
            };
            let add_js = (ev1) => {
                ev1.parentNode.style.display = "none";
                ev1.parentNode.removeAttribute("data-select");
                if (
                    !ev1
                        .closest(".item")
                        .contains(
                            ev1.closest(".item").querySelector("[data-select]")
                        )
                ) {
                    ev1.closest(".item").style.display = "none";
                    ev1.closest(".item").removeAttribute("data-selects");
                }
            };
            if (input.value.length > 2) {
                internetAddress_clear.style.display = "flex";
                for (let i = 0, len = data.length; i < len; i++) {
                    data[i].innerHTML
                        .toLowerCase()
                        .includes(query.toLowerCase())
                        ? clear_js(data[i])
                        : add_js(data[i]);
                }
                for (let i = 0, lens = list.length; i < lens; i++) {
                    if (
                        list[i].parentNode.querySelectorAll("[data-selects]")
                            .length == 0
                    ) {
                        internetAddress_list.style.display = "none";
                        internetAddress_help.style.display = "block";
                    } else {
                        internetAddress_list.style.display = "block";
                        internetAddress_help.style.display = "none";
                    }
                }
            } else {
                internetAddress_clear.style.display = "none";
                for (let i = 0, len = data.length; i < len; i++) {
                    data[i].parentNode.removeAttribute("style");
                    data[i].parentNode.removeAttribute("data-select");
                    data[i].closest(".item").removeAttribute("data-selects");
                    data[i].closest(".item").removeAttribute("style");
                    internetAddress_list.style.display = "block";
                    internetAddress_help.style.display = "none";
                }
            }
            f_check_height_block();
        });
        internetAddress_clear.onclick = function () {
            internetAddressInput.value = "";
            internetAddressInput.focus();
            sendOnChange(internetAddressInput);
            f_check_height_block();
        };
    }

    const show_more_address = document.querySelector(".show-more-address-js");
    const f_check_height_block = () => {
        const button = document.querySelector(".show-more-address-js");
        const block = document.querySelector(".check-height-address");
        const height_block = block.offsetHeight;
        if (height_block > 500) {
            block.classList.add("over-size");
            button.closest(".show-more-address").classList.remove("hide");
        } else {
            block.classList.remove("over-size");
            button.closest(".show-more-address").classList.add("hide");
        }
    };
    if (show_more_address) {
        f_check_height_block();
        show_more_address.onclick = function () {
            document.querySelector(".over-size").classList.remove("over-size");
            show_more_address
                .closest(".show-more-address")
                .classList.add("hide");
        };
    }

    // providers ajax
    let providers = document.querySelector("#providers_list");
    if (providers) {
        let provider_name = document.querySelector("[name=provider_name]");
        let provider_type = document.querySelector("[name=provider_type]");
        let provider_sort = document.querySelector("[name=provider_sort]");
        let provider_limit = providers.children.length;
        let provider_load_more = document.querySelector(".load-more");
        provider_name.addEventListener("change", function (e) {
            providersLoad(
                this.value,
                provider_type.value,
                provider_sort.value,
                providers
            );
        });
        provider_type.addEventListener("change", function (e) {
            providersLoad(
                provider_name.value,
                this.value,
                provider_sort.value,
                providers
            );
        });
        provider_sort.addEventListener("change", function (e) {
            providersLoad(
                provider_name.value,
                provider_type.value,
                this.value,
                providers
            );
        });

        providersLoad(
            provider_name.value,
            provider_type.value,
            provider_sort.value,
            providers,
            mobile ? 6 : 12
        );

        if (provider_load_more) {
            provider_load_more
                .querySelector("button")
                .addEventListener("click", function (e) {
                    e.preventDefault();
                    providersLoad(
                        provider_name.value,
                        provider_type.value,
                        provider_sort.value,
                        providers,
                        providers.children.length + 6
                    );
                });
        }

        function providersLoad(name, type, sort, pane, limit, from) {
            from = from ? from : 0;
            let url = "";
            if (!isSubdomain) {
                url = "/" + citySlug;
            }
            url +=
                "/providers-list/?provider_name=" +
                name +
                "&type=" +
                type +
                "&sort=" +
                sort +
                "&limit=" +
                limit +
                "&from=" +
                from;
            let loading = document.querySelector("#loading-img");
            if (loading != undefined) loading.style.display = "none";
            fetch(url)
                .then(function (response) {
                    return response.json();
                })
                .then(function (response) {
                    if (response.providers && response.success == true) {
                        pane.innerHTML = response.providers;

                        if (provider_load_more) {
                            if (response.has_more)
                                provider_load_more.style.display = "block";
                            else provider_load_more.style.display = "none";
                        }

                        initModal();
                        initTariffModal();
                        initRating();
                        initToggle();
                    } else {
                        if (type != "") {
                            pane.innerHTML =
                                '<div class="page-content__alert none">Провайдеры не найдены. <br>Попробуйте изменить параметры поиска.</div>';
                        }
                    }
                });
        }
    }

    // tariffs ajax
    let tariffs = document.querySelector("#tariffs_list");
    let reset_filter_tariffs = document.querySelector(".block-filter__reset");
    if (tariffs) {
        let providers_list = [];
        let type_list = [];
        let tariffs_count = document.querySelector(".tariffs_count");
        let tariffs_name = document.querySelectorAll("[name=provider_name]");
        let tariffs_type = document.querySelectorAll("[name=provider_type]");
        let tariffs_sort = document.querySelectorAll("[name=provider_sort]");
        let result_panel = document.getElementById('result-panel');
        let type_sort = result_panel.dataset.defaultSort;
        let tariffs_load_more = document.querySelector(".load-more");
        tariffs_name.forEach(function (element) {
            element.addEventListener("change", function () {
                if (!providers_list.includes(element.value)) {
                    providers_list.push(element.value);
                } else {
                    providers_list = providers_list.filter(function (item) {
                        return item !== element.value;
                    });
                }
                tariffsLoad();
            });
        });
        tariffs_type.forEach(function (element) {
            element.addEventListener("change", function () {
                if (!type_list.includes(element.value)) {
                    type_list.push(element.value);
                } else {
                    type_list = type_list.filter(function (item) {
                        return item !== element.value;
                    });
                }
                tariffsLoad();
            });
        });

        tariffs_sort.forEach(function (element) {
            element.addEventListener("change", function () {
                type_sort = element.value;
                tariffsLoad();
            });
        });

        tariffsLoad();
        if (tariffs_load_more) {
            tariffs_load_more
                .querySelector("button")
                .addEventListener("click", function (e) {
                    e.preventDefault();
                    tariffsLoad(tariffs.children.length + 6);
                });
        }

        if (reset_filter_tariffs) {
            reset_filter_tariffs.onclick = function (evt) {
                evt.preventDefault();
                clearFilterTarrifs();
                tariffsLoad();
            };
        }

        function clearFilterTarrifs() {
            let uncheck = document.getElementsByTagName("input");
            for (var i = 0; i < uncheck.length; i++) {
                if (uncheck[i].type == "checkbox") {
                    uncheck[i].checked = false;
                }
            }
            providers_list = [];
            type_list = [];
        }

        function tariffsLoad(limit, from) {
            limit = limit ? limit : mobile ? 10 : 10;
            from = from ? from : 0;

            let container = document.querySelector("#tariffs_list");
            let url = "";
            if (!isSubdomain) {
                url = "/" + citySlug;
            }

            if (providers_list.length || type_list.length) {
                reset_filter_tariffs.classList.remove("hide");
            } else {
                reset_filter_tariffs.classList.add("hide");
            }

            if (document.querySelector("input[name=provider_name_signle]")) {
                providers_list = document.querySelector(
                    "input[name=provider_name_signle]"
                ).value;
            }

            url += `/tariffs-list/?provider_name=${providers_list}&type=${type_list}&sort=${type_sort}&limit=${limit}&from=${from}`;

            if (document.querySelector("input[name=search]")) {
                url += "&" + document.querySelector("input[name=search]").value;
            }
            if (document.querySelector("input[name=sort_promo]")) {
                url += "&promo=1";
            }
            if (document.querySelector("input[name=conditions]")) {
                url +=
                    "&conditions=" +
                    document.querySelector("input[name=conditions]").value;
            }
            let loading = document.querySelector("#loading-img");
            if (loading != undefined) loading.style.display = "none";
            fetch(url)
                .then(function (response) {
                    return response.json();
                })
                .then(function (response) {
                    if (response.count !== 0) {
                        tariffs_count.innerHTML = `${declOfNum(response.count, [
                            "Найден",
                            "Найдено",
                            "Найдено",
                        ])} ${response.count} ${declOfNum(response.count, [
                            "тариф",
                            "тарифа",
                            "тарифов",
                        ])} от ${response.providers_count} ${declOfNum(
                            response.providers_count,
                            ["провайдера", "провайдеров", "провайдеров"]
                        )} `;
                    } else {
                        tariffs_count.innerHTML = `Найдено 0 тарифов`;
                    }
                    if (response.tariffs && response.success == true) {
                        container.innerHTML = response.tariffs;

                        if (tariffs_load_more) {
                            if (response.has_more)
                                tariffs_load_more.style.display = "block";
                            else tariffs_load_more.style.display = "none";
                        }

                        initTippyJS();
                        initModal();
                        initTariffModal();
                    } else {
                        container.innerHTML =
                            '<div class="page-content__alert none">Тарифы не найдены. <br>Попробуйте изменить параметры поиска.</div>';
                    }
                });
        }
    }

    // tariffs mobile ajax
    let tariffs_mobile = document.querySelector("#tariffs_list_mobile");
    if (tariffs_mobile) {
        let type_sort = "min_cost";
        let tariffs_count = document.querySelector(".tariffs_count");
        let tariffs_sort = document.querySelectorAll("[name=provider_sort]");
        let tariffs_load_more = document.querySelector(".load-more");

        let tariffs_provider = document.querySelectorAll(
            'input[name="provider_name[]"][type="checkbox"]'
        );
        let tariffs_messengers = document.querySelectorAll(
            'input[name="messengers[]"][type="checkbox"]'
        );

        tariffs_sort.forEach(function (element) {
            element.addEventListener("change", function () {
                type_sort = element.value;
                tariffsLoad();
            });
        });

        tariffs_messengers.forEach(function (element) {
            element.addEventListener("change", function () {
                tariffsLoad();
            });
        });

        tariffs_provider.forEach(function (element) {
            element.addEventListener("change", function () {
                tariffsLoad();
            });
        });


        tariffsLoad();
        if (tariffs_load_more) {
            tariffs_load_more
                .querySelector("button")
                .addEventListener("click", function (e) {
                    e.preventDefault();
                    tariffsLoad(tariffs.children.length + 6);
                });
        }

        function clearFilterTarrifs() {
            let uncheck = document.getElementsByTagName("input");
            for (var i = 0; i < uncheck.length; i++) {
                if (uncheck[i].type == "checkbox") {
                    uncheck[i].checked = false;
                }
            }
            providers_list = [];
            type_list = [];
        }

        function tariffsLoad(limit, from) {
            let providers = [];
            tariffs_provider.forEach((checkbox) => {
                if (checkbox.checked) {
                    providers.push(checkbox.value);
                }
            });
            const providers_list =
                providers && providers.length
                    ? `&provider_name=${providers.join(",")}`
                    : "";

            const traffic_min = document.querySelector(
                "#mobile_traffic_min"
            ).value;
            const traffic_max = document.querySelector(
                "#mobile_traffic_max"
            ).value;
            const traffic = `&traffic=${traffic_min},${traffic_max}`;

            const minute_min =
                document.querySelector("#mobile_minute_min").value;
            const minute_max =
                document.querySelector("#mobile_minute_max").value;
            const minute = `&minute=${minute_min},${minute_max}`;

            const payment_min = document.querySelector(
                "#mobile_payment_min"
            ).value;
            const payment_max = document.querySelector(
                "#mobile_payment_max"
            ).value;
            const coast = `&coast=${payment_min},${payment_max}`;

            const selectedMessengers = [];
            tariffs_messengers.forEach((checkbox) => {
                if (checkbox.checked) {
                    selectedMessengers.push(checkbox.value);
                }
            });
            const messengers_list =
                selectedMessengers && selectedMessengers.length
                    ? `&messengers=${selectedMessengers.join(",")}`
                    : "";

            limit = limit ? limit : mobile ? 10 : 10;
            from = from ? from : 0;

            let container = tariffs_mobile;
            let url = "";
            if (!isSubdomain) {
                url = "/" + citySlug;
            }

            url += `/mobile-list/?sort=${type_sort}&limit=${limit}&from=${from}${providers_list}${traffic}${minute}${coast}${messengers_list}`;

            if (document.querySelector("input[name=conditions]")) {
                url +=
                    "&conditions=" +
                    document.querySelector("input[name=conditions]").value;
            }

            let loading = document.querySelector("#loading-img");
            if (loading != undefined) loading.style.display = "none";
            fetch(url)
                .then(function (response) {
                    return response.json();
                })
                .then(function (response) {
                    if (response.count !== 0) {
                        tariffs_count.innerHTML = `${declOfNum(response.count, [
                            "Найден",
                            "Найдено",
                            "Найдено",
                        ])} ${response.count} ${declOfNum(response.count, [
                            "тариф",
                            "тарифа",
                            "тарифов",
                        ])}`;
                    } else {
                        tariffs_count.innerHTML = `Найдено 0 тарифов`;
                    }
                    if (response.tariffs && response.success == true) {
                        container.innerHTML = response.tariffs;

                        if (tariffs_load_more) {
                            if (response.has_more)
                                tariffs_load_more.style.display = "block";
                            else tariffs_load_more.style.display = "none";
                        }

                        initTippyJS();
                        initModal();
                        initTariffModal();
                    } else {
                        container.innerHTML =
                            '<div class="page-content__alert none">Тарифы не найдены. <br>Попробуйте изменить параметры поиска.</div>';
                    }
                });
        }
    }

    //Collapsible sidebar element
    var sidebarElements = document.getElementsByClassName(
        "sidebar__collapsible"
    );

    for (let i = 0; i < sidebarElements.length; i++) {
        sidebarElements[i].addEventListener("click", function () {
            this.classList.toggle("active");
        });
    }

    //Load more articles button
    var loadMoreButtons = document.getElementsByClassName("load-more-btn");
    let loadMoreFunction = async function () {
        let response = await fetch(this.dataset.url, {
            headers: {
                "X-Requested-With": "XMLHttpRequest",
            },
        });

        if (response.ok) {
            let html = await response.text();
            let list = this.parentElement.parentElement;
            let loadMoreBlocks = document.getElementsByClassName("load-more");
            while (loadMoreBlocks[0]) {
                loadMoreBlocks[0].parentNode.removeChild(loadMoreBlocks[0]);
            }

            list.innerHTML += html;
            loadMoreBlocks = document.getElementsByClassName("load-more-btn");
            if (loadMoreBlocks[0]) {
                loadMoreBlocks[0].addEventListener("click", loadMoreFunction);
            }
        } else {
            console.log("Ошибка HTTP: " + response.status);
        }
    };

    for (let i = 0; i < loadMoreButtons.length; i++) {
        loadMoreButtons[i].addEventListener("click", loadMoreFunction);
    }

    // send review form
    forEach(
        document.querySelectorAll(".js-modal-submit-review"),
        function (index, form) {
            const form_button = form.querySelector(".js-submit-form");
            let form_button_t = "";
            if (form_button) {
                form_button_t = form_button.innerHTML;
            }
            form.addEventListener("submit", (event) => {
                event.preventDefault();
                form_button.innerHTML = "Отправка...";

                let msg_el = form.querySelector(".message");
                let optionalFields = {
                    rev_internet: "[name=rev_internet]:checked",
                    rev_stable: "[name=rev_stable]:checked",
                    rev_help: "[name=rev_help]:checked",
                    rev_equip: "[name=rev_equip]:checked",
                    merits: "[name=merits]",
                    demerits: "[name=demerits]",
                };

                const smartTokenField = form.querySelector("[name=smart-token]");

                let request = {
                    _token: form.querySelector("[name=_token]").value,
                    provider: form.querySelector("[name=provider]").value,
                    rev_main: form.querySelector("[name=rev_main]:checked")
                        ? form.querySelector("[name=rev_main]:checked").value
                        : null,
                    review: form.querySelector("[name=review]").value,
                    yandex_token: smartTokenField && smartTokenField.value,
                };

                Object.keys(optionalFields).forEach(function (fieldName) {
                    let el = form.querySelector(optionalFields[fieldName]);
                    if (el && el.value) {
                        request[fieldName] = el.value;
                    }
                });

                postData(form.getAttribute("action"), request)
                    .then((data) => {
                        if (!data.success) {
                            let errorsMessages = "";

                            if (Array.isArray(data.errors)) {
                                errorsMessages = data.errors.join("<br />");
                            }

                            msg_el.innerHTML =
                                `<span class="error">` +
                                errorsMessages +
                                `</span>`;
                        } else {
                            msg_el.innerHTML = `<span class="success">Спасибо за отзыв!</span>`;

                            const reviewSuccessModal = document.getElementById('review-success-modal');
                            const reviewModal = document.getElementById('review-modal');

                            if (reviewModal) {
                                reviewModal.classList.remove('active');
                            }

                            if (reviewSuccessModal) {
                                reviewSuccessModal.classList.add('active');
                            }

                            form.reset();

                            const radioButtons = form.querySelectorAll('input[type="radio"]:checked');

                            radioButtons.forEach(radio => {
                                radio.checked = false;
                            });

                            const textFields = form.querySelectorAll('input[type="text"], textarea');

                            textFields.forEach(field => {
                                field.value = '';
                            });

                            setTimeout(() => {
                                msg_el.innerHTML = '';

                            }, 3000)
                        }

                        form_button.innerHTML = form_button_t;
                    })
                    .catch(function (error) {
                        msg_el.innerHTML = `<span class="error">Не удалось оставить отзыв, попробуйте позже.</span>`;
                        form_button.innerHTML = form_button_t;
                    });
            });
        }
    );

    forEach(
        document.querySelectorAll("textarea[name=review]"),
        function (index, textArea) {
            checkNote(textArea);
            textArea.addEventListener("keyup", function (event) {
                checkNote(textArea);
            });
        }
    );

    function checkNote(textArea) {
        let classesList = ["in-progress", "complete"];
        let minLength = textArea.getAttribute("minlength");
        let notes = document.querySelectorAll("[data-field-name=review]");
        let textAreaValueLength = textArea.value.length;

        if (notes.length > 0) {
            let note = notes[0];
            if (textAreaValueLength > 0 && textAreaValueLength < minLength) {
                note.classList.remove(...classesList);
                note.classList.add("in-progress");
            } else if (textAreaValueLength >= minLength) {
                note.classList.remove(...classesList);
                note.classList.add("complete");
            } else {
                note.classList.remove(...classesList);
            }

            let counters = note.querySelectorAll(".modal-reviews__note-value");
            if (counters.length > 0) {
                let counter = counters[0];
                counter.innerHTML = textAreaValueLength;
            }
        }
    }

    // check mobile city confirm
    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }

        // Получаем домен с текущего поддомена
        const domain = window.location.hostname.split('.').slice(-2).join('.');

        document.cookie = `${name}=${value}${expires}; path=/; domain=${domain}`;
    }

    function getCookie(name) {
        const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
        return match ? match[2] : null;
    }

    // проверка куки
    if (getCookie("check_city") === "none") {
        document.querySelectorAll(".header__mobile-check-city ").forEach(el => el.classList.add("hidden"));
        document.querySelectorAll(".header__mobile-city ").forEach(el => el.classList.remove("hidden"));
    } else {
        document.querySelectorAll(".header__mobile-check-city ").forEach(el => el.classList.remove("hidden"));
        document.querySelectorAll(".header__mobile-city ").forEach(el => el.classList.add("hidden"));
    }

    // установка куки при подтверждении города
    document.querySelectorAll(".confirm-city").forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault();
            setCookie("check_city", "none", 7);
            document.querySelectorAll(".header__mobile-check-city ").forEach(el => el.classList.add("hidden"));
            document.querySelectorAll(".header__mobile-city ").forEach(el => el.classList.remove("hidden"));
        });
    });

    // установка куки при клике по городу в списке городов
    document.getElementById("city-get").querySelectorAll('.city-list a').forEach(link => {
        link.addEventListener("click", function (event) {
            event.preventDefault();
            setCookie("check_city", "none", 7);
            window.location.href = link.href;
        })
    })

    const map = document.querySelector('.map-address');
    const openMapButton = document.querySelector('.hideMap');

    if (map && openMapButton) {
        openMapButton.addEventListener('click', () => {
            const buttonText = openMapButton.querySelector('p');

            map.classList.toggle('active');
            openMapButton.classList.toggle('active');

            if (openMapButton.classList.contains('active')) {
                buttonText.textContent = 'Показать карту'
            } else {
                buttonText.textContent = 'Скрыть карту'
            }
        });
    }
});
